import { extractTagEvaluation, hasLegacyNumericScores, hasTagEvaluation } from './evaluationDisplay';

export function hasNodeAiAnalysis(nodeAnalysis) {
  if (!nodeAnalysis) return false;
  return hasTagEvaluation(nodeAnalysis)
    || hasLegacyNumericScores(nodeAnalysis?.scores || nodeAnalysis)
    || extractTagEvaluation(nodeAnalysis) != null;
}

export function hasLensItemAiAnalysis(item) {
  if (!item) return false;
  return hasTagEvaluation(item.rag_references?.scores)
    || hasLegacyNumericScores(item.rag_references?.scores)
    || item.ai_confidence != null;
}

export function hasSolutionAiAnalysis(solution) {
  if (!solution?.ai_analysis) return false;
  const a = solution.ai_analysis;
  return !!(a.evaluation?.tags?.length || a.swot || a.researchSupport || a.overallAssessment);
}
